import { useAppSelector } from "@js/hooks/redux";

export const useUser = () => {
  return useAppSelector((state) => state.auth.user);
};
